<template>
  <active-button
    class="event-button"
    line-color="blue"
    line-position="left"
    :active="parseInt($route.params.event) === event.id"
    @click="$emit('click')"
  >
    <div class="team ellipsis">{{ event.home }}</div>
    <div
      class="team ellipsis"
      v-if="event.away !== undefined"
    >
      {{ event.away }}
    </div>
    <div class="comment">
      <div
        class="number blue-color"
        v-if="event.number"
      >
        {{ event.number }}
      </div>
      <div class="time">{{ event.time | moment('add', '-3 hours') | moment("DD/MM HH:mm") }}</div>
    </div>
  </active-button>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'

export default {
  components: {
    ActiveButton
  },
  props: {
    event: Object
  }
}
</script>

<style scoped>
.event-button { display: flex; flex-direction: column; font-size: 12px; background: hsla(0, 0%, 100%, .01) !important; padding: 5px 8px; }
.team { width: 100%; }
.comment { display: flex; width: 100%; }
.number { margin-right: 8px; }
.time { color: #aaa; }
</style>



// WEBPACK FOOTER //
// src/components/sports/menu/Event.vue